import { env as ienv } from '@/env/.env';
import CNPJ from '@/shared/cnpj.js';

export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

/**
 * Recebe a uma data e o formato e retorna a string da formatação.
 * year [y], month [M], day [d], hour [h], minute [m], second [s], quarter [q], millisecond [S]
 */
export function formatDate(date, format) {
  if (date == null) return;
  let dt = typeof(date) === "string" ? new Date(date) : date;

  if (!(dt instanceof Date) || isNaN(dt.getTime())) {
    console.error(`A data ${dt} não é uma data válida.`);
    return;
  }
  const o = {
    "M+": dt.getUTCMonth() + 1, // month
    "d+": dt.getUTCDate(), // day
    "h+": dt.getUTCHours(), // hour
    "m+": dt.getUTCMinutes(), // minute
    "s+": dt.getUTCSeconds(), // second
    "q+": Math.floor((dt.getUTCMonth() + 3) / 3), // quarter
    "S": dt.getUTCMilliseconds() // millisecond
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (dt.getUTCFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    let v = o[k];
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? v : `00${o[k]}`.substr(("" + v).length));
    }
  }
  return format;
};

export function requestError(error, ctx = null) {
  let showAlert = function (msg) {
    if (ctx) {
      ctx.$toasted.error(msg, {
        theme: "bubble",
        position: "top-right",
        duration: 5000
      });
    } else {
      alert(msg);
    }
  }
  if (error.response) {
    console.error(error.response);
    if (error.response.status !== 401 && error.response.status !== 403) {
      if (!error.response.data) {
        return showAlert(error.response.statusText);
      } else if (typeof error.response.data.detail === "string") {
        return showAlert(error.response.data.detail);
      } else if (error.response.data.detail && typeof error.response.data.detail.message === "string") {
        return showAlert(error.response.data.detail.message);
      } else if (error.response.data.detail && error.response.data.detail.detail && typeof error.response.data.detail.detail.message === "string") {
        return showAlert(error.response.data.detail.detail.message);
      } else if (error.response.data.detail && typeof error.response.data.detail.status === "string") {
        return showAlert(error.response.data.detail.status);
      } else {
        return showAlert("Erro inesperado!");
      }
    }
  } else {
    console.error(error);
    showAlert("Erro inesperado!");
  }
}

export function resolveRetailUserCredits(user = {}) {
  const genericCounterCredits = user.genericCounterCredits || {};
  const limitRules = user.billingLimits && user.billingLimits.limitRules ? user.billingLimits.limitRules : {};
  const login = genericCounterCredits.login || limitRules.login || 0;
  const signature = genericCounterCredits.signature || limitRules.signature || 0;
  return { login, signature };
}

export function normalizeRetailUserCredits(user = {}) {
  const normalizedUser = user;

  if (!normalizedUser.billingLimits) {
    normalizedUser.billingLimits = {};
  }
  if (!normalizedUser.billingLimits.limitRules) {
    normalizedUser.billingLimits.limitRules = {};
  }

  const credits = resolveRetailUserCredits(normalizedUser);
  normalizedUser.billingLimits.limitRules.login = credits.login;
  normalizedUser.billingLimits.limitRules.signature = credits.signature;

  return normalizedUser;
}

export function isAllowed(role) {
  if (localStorage.roles && JSON.parse(localStorage.roles).length) {
    return JSON.parse(localStorage.roles).includes(role);
  }
  return false;
}

function calcDigitPosition(digits, positions = 10, digitSum = 0) {
  digits = digits.toString();

  for (let i = 0; i < digits.length; i++) {
    digitSum = digitSum + digits[i] * positions;

    if (--positions < 2) {
      positions = 9;
    }
  }
  digitSum = digitSum % 11;

  if (digitSum < 2) {
    digitSum = 0;
  } else {
    digitSum = 11 - digitSum;
  }

  return digits + digitSum;
}

export function validateCPF(value) {
  value = value.toString();
  value = value.replace(/[^\d]/g, "");

  let digits = value.substr(0, 9);
  let newCpf = calcDigitPosition(digits);
  newCpf = calcDigitPosition(newCpf, 11);
  return newCpf === value;
}

export function validateCNPJ(value) {
  return CNPJ.isValid(value.toString().replace(/[^\da-zA-Z]/g, "").toUpperCase());
}

export function validateCPFCNPJ(value) {
  if (!value) {
    return true;
  }

  return validateCPF(value) || validateCNPJ(value);
}

export function validatePassword(password) {

  if (password == undefined || password == '') //Ignore validation
    return true;

  return Array.isArray(password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!.;{}()%*?&#\\\/\[\]]).{7,}$/));
}


export const env = ienv;
